import {
    selectTotalVisibleQuestionsWithAssistanceConditions,
    selectTotalVisibleQuestionsWithAssistance,
} from "features/qualityForm/qualityFormSlice";
import { useStrings } from "features/i18n/useStrings";
import { shallowEqual } from "react-redux";
import { GuxIcon, GuxTooltip } from "genesys-spark-components-react";
import "./AssistanceStatus.less";
import strings from "./AssistanceStatus.strings";
import { useAppSelector } from "app/hooks";

export function AssistanceStatus() {
    const t = useStrings(strings);
    const isAssistanceConfigured = useAppSelector((state) => {
        return (
            Object.values(state.qualityForm.data?.answerOptions ?? {}).find(
                (answerOption) =>
                    answerOption?.assistanceConditions !== undefined
            ) !== undefined
        );
    });

    const {
        totalQuestions,
        totalQuestionsWithAssistance,
        hasAssistanceFailed,
    } = useAppSelector((state) => {
        const totalQuestions =
            selectTotalVisibleQuestionsWithAssistanceConditions(state).length;
        const hasAssistanceFailed =
            (state.scorable.data?.scorable as any)?.hasAssistanceFailed ??
            false;

        const totalQuestionsWithAssistance =
            selectTotalVisibleQuestionsWithAssistance(state);
        return {
            totalQuestions,
            totalQuestionsWithAssistance,
            hasAssistanceFailed,
        };
    }, shallowEqual);
    return (
        <>
            {isAssistanceConfigured && (
                <div
                    className="AssistanceStatus"
                    data-testid="assistance-status"
                >
                    {!hasAssistanceFailed && (
                        <div className="question-status">
                            <span className="evaluation-assistance-quote">
                                <GuxIcon
                                    iconName="quote-left"
                                    decorative={true}
                                    data-testid="assistance-status-icon"
                                />
                            </span>

                            <span data-testid="assistance-status-count">
                                {t.status.questionCount[
                                    totalQuestionsWithAssistance === 1
                                        ? "singleQuestion"
                                        : "multipleQuestions"
                                ]({
                                    count: totalQuestionsWithAssistance,
                                })}
                            </span>
                            <GuxTooltip>
                                {t.status.tooltipText({
                                    answeredQuestionCount:
                                        totalQuestionsWithAssistance,
                                    totalQuestionCount: totalQuestions,
                                })}
                            </GuxTooltip>
                        </div>
                    )}
                </div>
            )}
        </>
    );
}
